import { render, staticRenderFns } from "./RewardManagement.vue?vue&type=template&id=104b31d0&scoped=true&"
import script from "./RewardManagement.vue?vue&type=script&lang=js&"
export * from "./RewardManagement.vue?vue&type=script&lang=js&"
import style0 from "./RewardManagement.vue?vue&type=style&index=0&id=104b31d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104b31d0",
  null
  
)

export default component.exports